import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import { templateDefaultValue } from "@constants/template";
import BannerImages from "../../Common/BannerImages";
import LanguageTable from "../../Common/LanguageTable";
import Preview from "../../Application/Fidelity/Preview";
import { templateActions } from "../../templateStore";
import { useSelector } from "react-redux";
function ApplicationFidelity({ selectedRows }: any) {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const [isReady, setIsReady] = React.useState(false);
    let schema: any = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    const boutique = schema + "_" + selectedRows[0].shopId;
    const bannierImagePath = React.useMemo(
        () => ["Application", "Loyalty", boutique, "Head", "Bannier"],
        [boutique]
    );
    const iconImagePath = React.useMemo(
        () => ["Application", "Loyalty", boutique, "Avantages", "Image"],
        [boutique]
    );

    const tabs = [
        {
            title: t("Solde section"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerImages
                                dataPath={bannierImagePath}
                                title="Image de la bannière"
                                size="(png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <LanguageTable
                            path={["Application", "Loyalty", boutique, "Solde"]}
                            fields={[
                                {
                                    key: "Title",
                                    label: "Titre",
                                    placeholder: "Enter the Title",
                                },
                                {
                                    key: "Info_1",
                                    label: "Message d'info 1",
                                    placeholder: "Enter the Titre",
                                },
                                {
                                    key: "Info_2",
                                    label: "Message d'info 2",
                                    placeholder: "Enter the Titre",
                                },
                                {
                                    key: "BottomTitle",
                                    label: "Titre bouton",
                                    placeholder: "Enter the Titre",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.Application.Loyalty.Default
                                    .Solde
                            }
                            sectionTitle="Section solde de fidélité"
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
        {
            title: t("Recompences section"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <LanguageTable
                            path={[
                                "Application",
                                "Loyalty",
                                boutique,
                                "Recompenses",
                            ]}
                            fields={[
                                {
                                    key: "Title",
                                    label: "Titre",
                                    placeholder: "Enter the Title",
                                },
                                {
                                    key: "BottomTitle",
                                    label: "Titre bouton",
                                    placeholder: "Enter the Titre",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.Application.Loyalty.Default
                                    .Recompenses
                            }
                            sectionTitle="Section récompenses de fidélité"
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
        {
            title: t("Advantages section"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerImages
                                dataPath={iconImagePath}
                                title="Perks icon unavailable"
                                size="50*50(png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <LanguageTable
                            path={[
                                "Application",
                                "Loyalty",
                                boutique,
                                "Avantages",
                            ]}
                            fields={[
                                {
                                    key: "Title",
                                    label: "Titre",
                                    placeholder: "Enter the Title",
                                },
                                {
                                    key: "Info_1",
                                    label: "Message d'info 1",
                                    placeholder: "Enter the Titre",
                                },
                                {
                                    key: "Info_2",
                                    label: "Message d'info 2",
                                    placeholder: "Enter the Titre",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.Application.Loyalty.Default
                                    .Avantages
                            }
                            sectionTitle="Section avantages de fidélité"
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }
    React.useEffect(() => {
        const ensureAllPaths = async () => {
            await templateActions.ensurePathExists(
                ["Application", "Loyalty", boutique],
                {
                    Head: {
                        Bannier: { Url: "", Name: "", Type: "", Extenxion: "" },
                    },
                    Solde:
                        templateDefaultValue.Application.Loyalty.Default.Solde,
                    Avantages: {
                        Image: { Url: "", Name: "", Type: "", Extenxion: "" },
                        ...templateDefaultValue.Application.Loyalty.Default
                            .Avantages,
                    },
                    Recompenses:
                        templateDefaultValue.Application.Loyalty.Default
                            .Recompenses,
                }
            );

            setIsReady(true);
        };

        ensureAllPaths();
    }, [boutique]);

    if (!isReady) return null;
    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "65% " }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => (
                            <NavItem
                                key={index}
                                className={classNames(
                                    "pb-1",
                                    "d-flex align-items-center text-nowrap",
                                    {
                                        "disable-nav-item__clz":
                                            activeTab !== index,
                                    },
                                    element.customClassName
                                )}
                                style={{
                                    cursor: "pointer",
                                    borderBottom:
                                        activeTab === index
                                            ? `${mainColor} 3px solid`
                                            : "",
                                }}
                            >
                                <NavLink
                                    className={classNames("text-dark w-100", {
                                        "active customer-account-menu-nav-link-active__clz":
                                            activeTab === index,
                                        "customer-account-menu-nav-link-disable__clz":
                                            activeTab !== index,
                                    })}
                                    onClick={() => toggleNav(index)}
                                >
                                    <span
                                        className="px-2"
                                        style={{
                                            font:
                                                "normal normal 600 20px/27px Segoe UI",
                                        }}
                                    >
                                        {element.title}
                                    </span>
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => (
                        <TabPane
                            tabId={index}
                            key={index}
                            style={{ height: "90%" }}
                        >
                            {element.content}
                        </TabPane>
                    ))}
                </TabContent>
            </div>
            <div style={{ width: "35%" }}>
                <Preview shopData={{ boutique: boutique }} />
            </div>
        </div>
    );
}

export default ApplicationFidelity;
